import React, { useRef, useState } from "react";
import "./ContactFormWithBackground.css";

import girlsImg2 from "../../assets/images/about/girls-hidden.png";
import whiteArrow from "../../assets/images/Home/whiteArrow.svg";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import axios  from "axios";

const ContactFormWithBackground = () => {
  const formRef = useRef(null);
  const [status, setStatus] = useState({ type: "idle", msg: "" });

  const siteName = process.env.REACT_APP_SITE_NAME || "unknown-site";

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const fullName = form.full_name?.value.trim() || "";
    const email = form.subscriber_email?.value.trim() || "";
    const message = form.message?.value.trim() || "";
    const phone = form.phone_number ? form.phone_number.value.trim() : "";
    const privacyChecked = form.privacy_agreed?.checked;

    // Honeypot — важно, чтобы поле было в форме


    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    delete data.company;
    if (form.company && form.company.value) {
      return;
    }

    // Валидация email
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus({
        type: "error",
        msg: "Please enter a valid email.",
      });
      return;
    }

    if (!fullName) {
      setStatus({
        type: "error",
        msg: "Please enter your full name.",
      });
      return;
    }

    if (!privacyChecked) {
      setStatus({
        type: "error",
        msg: "Please agree to the Privacy Policy.",
      });
      return;
    }

    setStatus({ type: "loading", msg: "Sending your request…" });

    try {
      const response = await axios.post('https://assembly.tehnik.tech/api/send_form/from',  {
        project: 'offshoreadvisory',
        subject: '/',
        data: data // все данные формы
      }, {

        headers: {
          'Content-Type': 'application/json',

        }
      });

      form.reset();
      setStatus({
        type: "success",
        msg: "Thank you! Your request has been sent.",
      });
    } catch (err) {
      console.error(err);
      setStatus({
        type: "error",
        msg: "Couldn’t send the form right now. Please try again.",
      });
    }
  };

  return (
    <div className="contact-background-gray">
      <div className="contact-container-block">
        <div className="contact-container-left">
          <img src={girlsImg2} alt="Contact" />
        </div>

        <div className="contact-container-right">
          <h2 className="contact-container-title">
            We’re thrilled to hear from you!
          </h2>

          <form ref={formRef} onSubmit={onSubmit} noValidate>
            <div className="input-wrapper">
              <input
                type="text"
                name="full_name"
                placeholder="Full name *"
                required
              />
            </div>

            <div className="input-wrapper">
              <input
                type="email"
                name="subscriber_email"
                placeholder="Email *"
                required
              />
            </div>

            {/* Если нужен телефон — просто раскомментируй */}
            {/* <div className="input-wrapper">
              <input
                type="tel"
                name="phone_number"
                placeholder="Phone (optional)"
              />
            </div> */}

            <div className="textarea-wrapper">
              <textarea
                name="message"
                placeholder="Short Brief"
                rows={4}
              />
            </div>

            {/* Honeypot (скрытое поле для ботов) */}
            <input
              type="text"
              name="company"
              tabIndex={-1}
              autoComplete="off"
              className="cf-hp"
              aria-hidden="true"
            />

            <div className="agree-sending">
              <div className="agree-content">
                <input
                  type="checkbox"
                  name="privacy_agreed"
                  id="privacy_agreed"
                />
                <p>
                  I agree to{" "}
                  <Link to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </p>
              </div>

              <button
                type="submit"
                disabled={status.type === "loading"}
              >
                {status.type === "loading" ? "Sending…" : "Get Consultation"}
                <img src={whiteArrow} alt="" />
              </button>
            </div>

            {/* Статус отправки */}
            <div
              className={`contact-status contact-status--${status.type}`}
              aria-live="polite"
            >
              {status.msg}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactFormWithBackground;
